var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3194,
    height: 3194,
    viewBox: "0 0 3194 3194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1619.26 0.437413C721.347 -11.6903 -11.6903 721.347 0.437413 1619.26C12.4116 2480.41 713.594 3181.59 1574.74 3193.56C2472.81 3205.84 3205.69 2472.81 3193.41 1574.89C3181.59 713.594 2480.41 12.4116 1619.26 0.437413ZM2589.63 2512.34C2586.57 2515.64 2582.83 2518.24 2578.66 2519.93C2574.48 2521.63 2569.99 2522.39 2565.49 2522.15C2560.99 2521.92 2556.6 2520.7 2552.63 2518.58C2548.66 2516.46 2545.2 2513.49 2542.5 2509.88C2473.85 2420.05 2389.77 2343.15 2294.19 2282.75C2098.77 2157.33 1851.15 2088.25 1597 2088.25C1342.85 2088.25 1095.23 2157.33 899.809 2282.75C804.235 2343.12 720.157 2420 651.497 2509.8C648.8 2513.41 645.342 2516.38 641.369 2518.5C637.396 2520.62 633.006 2521.84 628.508 2522.08C624.011 2522.31 619.517 2521.55 615.345 2519.86C611.173 2518.16 607.426 2515.57 604.368 2512.26C379.136 2269.12 251.55 1951.41 246.062 1620.03C233.551 873.097 846.462 247.905 1593.7 246.062C2340.94 244.22 2947.94 850.991 2947.94 1597C2948.19 1936.38 2820.21 2263.32 2589.63 2512.34Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1597 737.312C1445.63 737.312 1308.77 794.037 1211.52 897.122C1114.27 1000.21 1065.68 1142.75 1076.66 1295.73C1098.92 1597 1332.34 1842.62 1597 1842.62C1861.66 1842.62 2094.62 1597 2117.34 1295.8C2128.7 1144.28 2080.5 1003.05 1981.63 898.043C1884 794.42 1747.37 737.312 1597 737.312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCircleOutline);
export default __webpack_public_path__ + "static/media/person-circle-outline.b18d83a533b6d4d10eaf240dbe8c987b.svg";
export { ForwardRef as ReactComponent };